class r {
  constructor() {
  }
  validate(a) {
    return !!a.match(/^[0-9]+$/);
  }
}
export {
  r as default
};
